<template>
    <div class="row" v-if="campaign.length>0">
        <div class="col-12 text-center mb-4">
            <mdb-btn color="indigo btn-kamp-blue" tag="a" href="https://youtube.com/playlist?list=PL8bPdvGnCzqnBdHJNWtzI9sy-QkU-lw0G" >
                Uçak Bileti Kampanyaları</mdb-btn>
        </div>
        <div class="col-12 col-md-4">
            <mdb-view>
                <a href="#">
                    <img :src="campaign[0].cover" class="img-fluid" alt="placeholder">
                    <mdb-mask class="image-bottom-title" overlay="teal-slight" :text="campaign[0].description" />
                </a>
            </mdb-view>
        </div>
        <div class="col-12 col-md-4">
                <mdb-view >
                    <a href="#">
                        <img :src="campaign[1].cover" style="" class="img-fluid">
                        <mdb-mask class="image-bottom-title" overlay="teal-slight" :text="campaign[1].description" ></mdb-mask>
                    </a>
                </mdb-view>
        </div>
        <div class="col-12 col-md-4">
            <mdb-view >
                <a href="#">
                    <img :src="campaign[2].cover" style="" class="img-fluid">
                    <mdb-mask class="image-bottom-title" overlay="teal-slight" :text="campaign[2].description" ></mdb-mask>
                </a>
            </mdb-view>
        </div>
        <div v-if="tumKampanya" class="col-12 text-center mt-4">
            <mdb-btn color="indigo btn-red" to="/kampanyalar"><router-link to="/kampanyalar"class="text-white">Tüm Kampanyaları Listele</router-link></mdb-btn>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import { mdbContainer, mdbCol, mdbRow, mdbIcon, mdbTabs, mdbJumbotron, mdbView, mdbMask, mdbBtn, mdbTextarea, mdbInput, mdbCarousel, mdbCarouselItem,mdbCard, mdbCardImage, mdbCardBody, mdbCardTitle, mdbCardText, mdbCarouselCaption } from 'mdbvue';

    export default {
        props:{
            tumKampanya:{
                type: Boolean,
                default:true
            }
        },
        name: "centerKampanya.vue",
        components: {
            mdbContainer,
            mdbCol,
            mdbRow,
            mdbIcon,
            mdbTabs,
            mdbJumbotron,
            mdbView,
            mdbMask,
            mdbBtn,
            mdbTextarea,
            mdbInput,
            mdbCarouselItem,
            mdbCard,
            mdbCardImage,
            mdbCardBody,
            mdbCardTitle,
            mdbCardText,
            mdbCarousel,
            mdbCarouselCaption,

        },
        data: () => ({
            title:'Yurt Dışı En Uygun Uçak Biletleri',
            remoteUrl:'https://www.biletbul.com/biletbul/backend/public',
            icon:'chevron-right',
            currency : ['₺','$','€'],
            campaign: [],
        }),
        mounted() {

            axios.get("https://www.biletbul.com/backend/public/api/v1/campaign",{
                headers: {

                }
            })
                .then(response => this.campaign=[...response.data.data])
        }
    }
</script>

<style scoped>

</style>
